import { ClassroomCardActionsEnum, IClassroomCardOption } from './models';

export const menuOptions: IClassroomCardOption[] = [
  {
    id: ClassroomCardActionsEnum.schedule_meeting,
    label: 'classrooms.menu.schedule',
    enabled: (classroom) => classroom.can?.schedule_meeting,
  },

  {
    id: ClassroomCardActionsEnum.pin,
    label: 'classrooms.menu.pin',
    enabled: (classroom, state) => !!classroom && !state.is_pined,
  },
  {
    id: ClassroomCardActionsEnum.unpin,
    label: 'classrooms.menu.unpin',
    enabled: (classroom, state) => !!classroom && state.is_pined,
  },
  {
    id: ClassroomCardActionsEnum.edit,
    label: 'classrooms.menu.edit',
    enabled: (classroom) => classroom?.can?.edit,
  },
  {
    id: ClassroomCardActionsEnum.invite,
    label: 'classrooms.menu.invite',
    enabled: (classroom) => classroom?.can?.invite,
  },
  {
    id: ClassroomCardActionsEnum.leave,
    label: 'classrooms.menu.leave',
    enabled: (classroom) => classroom?.can?.leave,
  },
  {
    id: ClassroomCardActionsEnum.break_contract,
    label: 'classrooms.menu.cancel',
    enabled: (classroom) => classroom?.user_service_contract?.can?.break,
  },
  {
    id: ClassroomCardActionsEnum.archive,
    label: 'classrooms.menu.delete',
    enabled: (classroom) => classroom?.can?.archive,
  },
  {
    id: ClassroomCardActionsEnum.restore,
    label: 'classrooms.menu.restore',
    enabled: (classroom) => classroom?.can?.restore,
  },
  // DONE classroom?.can?.edit = /** Могу изменить общие сведения */
  // DONE classroom?.can?.invite = /** Могу пригласить участников */
  // TODO classroom?.can?.withdrawInvitation = /** могу отозвать приглашение */
  // TODO classroom?.can?.acceptInvitation = /** Могу принять приглашение */
  // TODO classroom?.can?.declineInvitation = /** Могу отклонить приглашение */
  // classroom?.can?.join = /** Могу присоединиться (по ссылке) */
  // DONE classroom?.can?.leave = /** Могу покинуть */
  // classroom?.can?.authJoin = /** Смогу присоединиться (по ссылке) после авторизации */
  // classroom?.can?.authPaidJoin = /** Смогу присоединиться (по ссылке) с оплатой после авторизации */
  // DONE classroom?.can?.archive = /** Могу архивировать */
  // DONE  classroom?.can?.restore = /** Могу восстановить из архива */
  // DONE classroom?.can?.schedule_meeting = /** Могу создать митинг */
  // TODO classroom?.can?.manage_content = /** Могу управлять контентом в комнате */
  // TODO classroom?.can?.manage_tasks = /** Могу назначать и проверять задания для участников комнаты */
  // TODO classroom?.can?.assign_assistant = /** Могу назначать ассистента */
  // TODO classroom?.can?.assign_replacement_teacher = /** Могу назначать преподавателя на замену */
  // TODO classroom?.can?.join_user_service_contract = /** Могу записаться на услугу */
  // DONE classroom?.can?.break_user_service_contract = /** Могу прекратить занятия по услуге */
  // TODO classroom?.can?.chat = /** Могу пользоваться чатом */
];

export interface BreakContractReasonData {
  type: 'info' | 'warning' | 'error' | 'success';
  icon: string;
  title: string;
  description: string;
  closeBtnText: string;
  confirmBtnText: string;
}

export interface BreakContractReasonsData {
  no_classes: BreakContractReasonData;
  left_classes: BreakContractReasonData;
  less_24_hours: BreakContractReasonData;
}

export interface BreakContractTypeData {
  course: BreakContractReasonsData;
  regular: BreakContractReasonsData;
}

export const classBreakReasonsData: BreakContractTypeData = {
  regular: {
    no_classes: {
      type: 'warning',
      icon: 'think',
      title: 'classrooms.class-break-reasons.regular.no_classes.title',
      description: 'classrooms.class-break-reasons.regular.no_classes.description',
      closeBtnText: 'classrooms.class-break-reasons.regular.no_classes.cancel',
      confirmBtnText: 'classrooms.class-break-reasons.regular.no_classes.confirm',
    },
    left_classes: {
      type: 'warning',
      icon: 'think',
      title: 'classrooms.class-break-reasons.regular.left_classes.title',
      description: 'classrooms.class-break-reasons.regular.left_classes.description',
      closeBtnText: 'classrooms.class-break-reasons.regular.left_classes.cancel',
      confirmBtnText: 'classrooms.class-break-reasons.regular.left_classes.confirm',
    },
    less_24_hours: {
      type: 'error',
      icon: 'scary',
      title: 'classrooms.class-break-reasons.regular.less_24_hours.title',
      description: 'classrooms.class-break-reasons.regular.less_24_hours.description',
      closeBtnText: 'classrooms.class-break-reasons.regular.less_24_hours.cancel',
      confirmBtnText: 'classrooms.class-break-reasons.regular.less_24_hours.confirm',
    },
  },
  course: {
    no_classes: {
      type: 'warning',
      icon: 'think',
      title: 'classrooms.class-break-reasons.course.no_classes.title',
      description: 'classrooms.class-break-reasons.course.no_classes.description',
      closeBtnText: 'classrooms.class-break-reasons.course.no_classes.cancel',
      confirmBtnText: 'classrooms.class-break-reasons.course.no_classes.confirm',
    },
    left_classes: {
      type: 'warning',
      icon: 'think',
      title: 'classrooms.class-break-reasons.course.left_classes.title',
      description: 'classrooms.class-break-reasons.course.left_classes.description',
      closeBtnText: 'classrooms.class-break-reasons.course.left_classes.cancel',
      confirmBtnText: 'classrooms.class-break-reasons.course.left_classes.confirm',
    },
    less_24_hours: {
      type: 'error',
      icon: 'scary',
      title: 'classrooms.class-break-reasons.course.less_24_hours.title',
      description: 'classrooms.class-break-reasons.course.less_24_hours.description',
      closeBtnText: 'classrooms.class-break-reasons.course.less_24_hours.cancel',
      confirmBtnText: 'classrooms.class-break-reasons.course.less_24_hours.confirm',
    },
  },
};
